<!-- =========================================================================================
  File Name: DeviceCategorySidebar.vue
  Description: Category - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<i18n src="@/locales/modules/DepartmentTranslate.json"></i18n>

<template>
	<el-dialog
		class="custom-dialog deparment-category-dialog"
		:title="$t('Department')"
		:visible.sync="isSidebarActiveLocal"
		:closed="() => $store.dispatch('departmentManagement/toggleDepartmentCategorySideBar', { status: false })"
	>
		<PerfectScrollbar class="scroll-area--data-list" :settings="settings">
			<div class="">
				<div slot="header" class="flex flex-grow justify-end bg-gray-7 p-6">
					<vs-input size="large" class="input-search mr-3 flex-1" icon="search" :placeholder="$t('Actions.Search')" v-model="searchText" />

					<vs-button v-if="mixinIsCanCreateDepartment" type="filled" class="w-auto sm:w-1/4 font-bold" @click="addNewData">{{ $t("Actions.AddNew") }}</vs-button>
				</div>
				<liquor-tree class="mt-5 overflow-visible sm:overflow-auto px-6" :key="treeDataKey" :options="{ parentSelect: true }" :data="treeCategories">
					<div class="tree-text tree-item w-full flex justify-between" slot-scope="{ node }">
						<div @click="showDepartmentDetail(node)" class="content tree-item__content">
							<template v-if="!node.hasChildren()">
								<i class="mr-3 nucleo nucleo-shape-oval-3"></i>
								{{ node.text }}
							</template>

							<template v-else>
								<i :class="[node.expanded() ? 'mr-2 nucleo nucleo-shape-oval-3' : 'mr-2 nucleo nucleo-e-add']"></i>
								{{ node.text }}
							</template>
						</div>

						<DepartmentContextMenu type="vertical" :department="node.data" @onClickEdit="editData" @onClickDelete="showDeleteConfirm" @onClickManageTitle="handleManageTitle" />
					</div>
				</liquor-tree>
			</div>
		</PerfectScrollbar>

		<popup-create-or-update-departmant-item :isPopupActive="isPopupActive" @closePopup="toggleCategoryPopup" :data="popupData" />
		<DepartmentDetailDialog
			v-if="isDetailDepartmentDialogActive"
			:department="detailDepartmentDialogData"
			:isSidebarActive="isDetailDepartmentDialogActive"
			@closeSidebar="toggleDepartmentDetailSidebar"
			@onClickEdit="editData"
			@onClickDelete="showDeleteConfirm"
			@onClickManageTitle="handleManageTitle"
		/>

		<TitlesByDepartmentDialog v-if="isTitlesDepartmentActive" :department="titlesDepartmentData" :isSidebarActive="isTitlesDepartmentActive" @closeSidebar="toggleTitlesDepartmentSidebar" />
	</el-dialog>
</template>

<script>
import { departmentPermissions, getUserPermissions } from "@/mixins/mixins.js";
import { mapGetters } from "vuex";
import LiquorTree from "liquor-tree";

import PopupCreateOrUpdateDepartmantItem from "./PopupCreateOrUpdateDepartmantItem.vue";
import "vue-tree-halower/dist/halower-tree.min.css";
import DepartmentContextMenu from "./DepartmentContextMenu.vue";
import DepartmentDetailDialog from "./DepartmentDetailDialog.vue";
import TitlesByDepartmentDialog from "./TitlesByDepartmentDialog.vue";
import * as _ from "lodash";
export default {
	mixins: [getUserPermissions(departmentPermissions)],
	props: {
		isSidebarActive: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
			isPopupActive: false,

			popupData: {},
			treeDataKey: 0,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			searchText: "",
			isDetailDepartmentDialogActive: false,
			detailDepartmentDialogData: null,
			isTitlesDepartmentActive: false,
			titlesDepartmentData: null
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		...mapGetters({
			getTreeDepartments: "departmentManagement/getTreeDepartments"
		}),
		treeCategories() {
			this.forceRerender();
			const _tree = _.cloneDeep(this.getTreeDepartments);

			return (
				_tree.filter(item => {
					return this.loopSearchInTree(item);
				}) || []
			);
		}
	},
	methods: {
		forceRerender() {
			this.treeDataKey += 1;
		},
		toggleCategoryPopup(val = false) {
			this.isPopupActive = val;
		},
		toggleDepartmentDetailSidebar(val = false) {
			this.isDetailDepartmentDialogActive = val;
		},
		toggleTitlesDepartmentSidebar(val = false) {
			this.isTitlesDepartmentActive = val;
		},
		addNewData() {
			this.popupData = {};
			this.toggleCategoryPopup(true);
		},
		async editData(data) {
			try {
				const response = await this.$store.dispatch("departmentManagement/getDetailDepartment", { id: data.id });
				await this.$store.dispatch("rolesManagement/fetchRoles", {});
				this.popupData = response.department || {};
				this.toggleCategoryPopup(true);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			}
		},
		showDeleteConfirm(department) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteData(department.id),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		async deleteData(id) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("departmentManagement/deleteDepartment", { id: id });
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteDepartmentSuccessful")
					}
				});
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		loopSearchInTree(item) {
			if (this.$helper.nonAccentVietnamese(item.text).includes(this.$helper.nonAccentVietnamese(this.searchText.trim()))) {
				item.state = { visible: true, expanded: true };
			} else {
				item.state = { visible: false, expanded: true };
			}
			if (item.children && item.children.length > 0) {
				const isExistInChilds = item.children.filter(itemChil => {
					return this.loopSearchInTree(itemChil);
				});
				isExistInChilds.map(chil => {
					if (chil.state.visible) {
						item.state = { visible: true, expanded: true };
						return item;
					}
				});
			} else {
				const isIncludes = this.$helper.nonAccentVietnamese(item.text).includes(this.$helper.nonAccentVietnamese(this.searchText.trim()));
				if (isIncludes) {
					item.state = { visible: true, expanded: true };
				} else {
					item.state = { visible: false, expanded: true };
				}
			}
			return item;
		},
		async showDepartmentDetail(dep) {
			const response = await this.$store.dispatch("departmentManagement/getDetailDepartment", { id: dep.id });

			this.detailDepartmentDialogData = response.department;
			this.toggleDepartmentDetailSidebar(true);
		},
		async handleManageTitle(department) {
			await this.$store.dispatch("rolesManagement/fetchRoles", {});
			const response = await this.$store.dispatch("departmentManagement/getDetailDepartment", { id: department.id });
			this.titlesDepartmentData = _.cloneDeep(response.department);
			this.toggleTitlesDepartmentSidebar(true);
		}
	},
	components: {
		LiquorTree,
		PopupCreateOrUpdateDepartmantItem,
		DepartmentContextMenu,
		DepartmentDetailDialog,
		TitlesByDepartmentDialog
	},

	created() {
		this.$store.subscribe(mutaion => {
			if (mutaion.type === "departmentManagement/SET_DEPARTMENT_CATEGORY_SIDEBAR_STATUS" && mutaion.payload) {
				this.$store.dispatch("departmentManagement/fetchDepartments", {
					limit: -1
				});
			}
		});
	}
};
</script>

<style lang="scss" scoped>
.deparment-category-dialog {
	.scroll-area--data-list {
		height: auto;
		background-color: #fff;
		max-height: 100%;
	}

	::v-deep .tree {
		.tree-arrow {
			display: none;
		}

		.tree-text {
			.tree-item__content {
				.nucleo {
					color: #bdbdbd;
					font-size: 3px;

					&::before {
						font-weight: bold;
					}
				}
			}
		}
	}
}
</style>
